import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
  Avatar,
  FormControl,
  Select,
  MenuItem,
  Switch,
  Popover,
} from "@mui/material";

import { useMutation, useQuery } from "@apollo/client";
import {
  LIST_MATERIAL_UNIT,
  UPDATE_LIST_MATERIAL_UNIT_IS_USE,
} from "../../Schema/ListMaterialUnit";
import CreateIcon from "../../Assets/create-icon.svg";
import EmptyImage from "../../Assets/empty-image.png";
import { AuthContext } from "../../Context/AuthContext";
import ListMaterialUnitForm from "../../Components/Material/ListMaterialUnitForm";
import ListMaterialUnitAction from "../../Components/Material/ListMaterialUnitAction";
import LoadingPage from "../../Components/Include/LoadingPage";
import EmptyData from "../../Components/Include/EmptyData";
import Paper from "@mui/material/Paper";
import ViewMeterialUnit from "./ViewMeterialUnit";

export default function ListMaterialUnit({ materialId }) {
  //================ ====================
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openView, setOpenView] = useState(false);
  const handleOpenView = () => setOpenView(true);
  const handleCloseView = () => setOpenView(false);

  const { refetch } = useQuery(LIST_MATERIAL_UNIT, {
    variables: { materialId: materialId?._id },
    onCompleted: ({ getListMaterialUnit }) => {
      setTableData(getListMaterialUnit);
      setLoading(false);
    },
    onError: (err) => {
      setLoading(true);
      console.log("Error::", err?.message);
    },
    // pollInterval: 1000
  });

  const [updateListMaterialUnitIsUse] = useMutation(
    UPDATE_LIST_MATERIAL_UNIT_IS_USE,
    {
      onCompleted: ({ updateListMaterialUnitIsUse }) => {
        console.log("updateListMaterialUnitIsUse", updateListMaterialUnitIsUse);
        if (updateListMaterialUnitIsUse?.status) {
          setAlert(true, "success", updateListMaterialUnitIsUse?.message);
        } else {
          setAlert(true, "error", updateListMaterialUnitIsUse?.message);
        }
      },
      onError: (error) => {
        setAlert(true, "error", error?.message);
      },
    }
  );

  const handleUpdateStatus = (id, isUse) => {
    updateListMaterialUnitIsUse({
      variables: {
        id,
        isUse,
      },
      onCompleted: () => {
        setTableData((prevData) =>
          prevData.map((unit) =>
            unit._id === id ? { ...unit, isUse: !unit.isUse } : unit
          )
        );
      },
    });
  };



  // 
  const [anchorEl, setAnchorEl] = React.useState(null); 
  const handlePopoverOpen = (event) => {
    // getStudentEnrollmentInfo({ variables: { id: id } });
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const openAnchor = Boolean(anchorEl);

  return (
    <Box>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ល.រ</TableCell>
              {/* <TableCell width="6%">ISBN</TableCell> */}
              <TableCell>ខ្នាត</TableCell>
              <TableCell>តម្លៃក្នុង១ឯកតា</TableCell>
              <TableCell>ចំនួនក្នុងឯកតា</TableCell>
              <TableCell>ចំណាំ </TableCell>
              <TableCell width="10%">ការប្រើប្រាស់</TableCell>
              <TableCell>
                <Stack direction="row" justifyContent="right">
                  <Button
                    variant="contained"
                    onClick={handleOpen}
                    startIcon={<img src={CreateIcon} alt="CreateIcon" />}
                  >
                    បង្កើត
                  </Button>
                </Stack>
              </TableCell>
            </TableRow>
          </TableHead>

          {loading ? (
            <LoadingPage colSpan={7} />
          ) : tableData?.length === 0 ? (
            <EmptyData colSpan={7} />
          ) : (
            <TableBody>
              {tableData?.map((row, index) => {
                // console.log("tableData",tableData)
                return (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {index + 1}
                    </TableCell>
                    {/* <TableCell> 
                      {row?.barcode}
                    </TableCell> */}
                    <TableCell
                      onClick={handleOpenView}
                      sx={{ cursor: "pointer" }}
                    >
                      <Stack 
                        direction="row" 
                        spacing={1}                       
                        onMouseEnter={handlePopoverOpen}
                        onMouseLeave={handlePopoverClose}
                      >
                        <Avatar
                          sx={{ width: 40, height: 40, borderRadius: 0 }}
                          alt={row?.unitId?.unitEnName}
                          src={row?.imageSrc}
                        />
                        <Stack direction="column" justifyContent="center">
                          <Typography fontWeight="bold">
                            {row?.unitId?.unitEnName}
                          </Typography>
                        </Stack>
                      </Stack> 

                      <Popover
                          id="mouse-over-popover"
                          sx={{
                            pointerEvents: "none",
                          }}
                          open={openAnchor}
                          anchorEl={anchorEl}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          onClose={handlePopoverClose}
                          disableRestoreFocus
                        >
                          <Stack
                            direction="row"
                            spacing={1} 
                            alignItems={"ceneter"}
                            // width={440}
                          > 
                            <img
                              src={row?.imageSrc}
                              al="Main"
                              style={{
                                width: "190px", 
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />                             
                          </Stack>
                        </Popover>
                    </TableCell>
                    <TableCell
                      onClick={handleOpenView}
                      sx={{ cursor: "pointer" }}
                    >
                      {" "}
                      {row?.costPerUnit?.toFixed(2)} $ /{" "}
                      {row?.unitId?.unitEnName}
                    </TableCell>
                    <TableCell
                      onClick={handleOpenView}
                      sx={{ cursor: "pointer" }}
                    >
                      {row?.qtyInUnit}{" "}
                      {row?.materialId?.smallUnitId?.unitEnName} /{" "}
                      {row?.unitId?.unitEnName}
                    </TableCell>
                    <TableCell
                      onClick={handleOpenView}
                      sx={{ cursor: "pointer" }}
                    >
                      {" "}
                      {row?.remark}
                    </TableCell>
                    <TableCell align="center">
                      <Switch
                        size="small"
                        checked={row.isUse}
                        onChange={(e) =>
                          handleUpdateStatus(row?._id, !row?.isUse)
                        }
                      />
                    </TableCell>
                    <TableCell align="right">
                      <ListMaterialUnitAction
                        editData={row}
                        setRefetch={refetch}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <ListMaterialUnitForm
        open={open}
        handleClose={handleClose}
        setRefetch={refetch}
        materialId={materialId}
        dialogTitle="Create"
      />

      <ViewMeterialUnit
        editData={tableData}
        open={openView}
        handleClose={handleCloseView}
        setRefetch={refetch}
      />
    </Box>
  );
}
